import { useEffect, useRef } from 'react';
// import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import './GameResults.css';
import { usePageNavigation } from '../../hooks/usePageNavigation';
import { HeaderH1 } from '../../components/promo/HeaderH1';
import { Stars } from './Stars/Stars';
import useComputeRank from '../../hooks/useComputeRank';

export const GameResults = () => {
  const { __t } = useTranslation();
  // const { pagesMap } = usePageConfig();
  const parentNode = 'SCAN_CONFIRMATION';
  const pageData = __t(parentNode);
  console.log('ScanConfirmation pageData=', pageData);
  const { goToPage } = usePageNavigation();
  const header = __t('h1', 'END_GAME');
  const headerClassName = () => {
    if (header.length < 13) {
      return 'headerH1';
    } else if (header.length > 16) {
      return 'headerH1 h1-long';
    } else {
      return 'headerH1 h1-mid';
    }
  };
  const gameCharacter = useStore((state) => state.gameCharacter);

  const characters = __t('characters', 'CHARACTER_SELECTION');
  const characterObj = characters.find(
    (c: LocaleJson.Character) => c.slug === gameCharacter
  );
  const pokemonName =
    characterObj?.slug.charAt(0).toUpperCase() + characterObj?.slug.slice(1);
  console.log('gameCharacter=', gameCharacter, 'characterObj=', characterObj);
  // @ts-ignore
  const stars = useComputeRank()()[2] as number;
  console.log('stars', stars);
  const movesCount = useStore((state) => state.movesCount);
  const movesCountTextRef = useRef(
    __t('bodyCopy1', 'END_GAME').replace('[x]', movesCount)
  );
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  const endGameFactClassName = () => {
    if (characterObj?.endGameFact.length > 45) {
      return 'HeaderH1-border HeaderH1-border-long';
    } else {
      return 'HeaderH1-border';
    }
  };
  useEffect(() => {
    setPageTitle(__t('pageTitle', 'END_GAME'));
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  return (
    <section
      id="game-results-container"
      className="game-results"
      role="dialog"
      aria-modal="true"
      style={{
        backgroundImage: `url(${__t('backgrounds.main', 'GENERAL')})`,
      }}
    >
      <div className="game-results-content">
        <div className="game-results-wrapper">
          <div className="headerH1-wrap">
            <div
              aria-hidden={true}
              className={headerClassName()}
              id="endGameHeader"
              heading-text={header}
            >
              {header}
            </div>
            <h1 aria-hidden={false} className={`headerH1-a11y`}>
              {header}
            </h1>
            <Stars stars={stars} />

            <h2 className="game-results-move">{movesCountTextRef.current}</h2>
          </div>
          <div
            className="game-results-box"
            aria-label={characterObj?.ariaLabel}
            role="img"
            aria-hidden={true}
          >
            <img
              src={characterObj?.imgSrc}
              className="game-results-sprite-image"
              data-character={characterObj?.slug}
              alt={characterObj?.ariaLabel}
            />
            <div
              className="game-results-sprite-shadow"
              aria-hidden="true"
            ></div>
          </div>
          <p className="character-name">{pokemonName}</p>
          <p className={endGameFactClassName()}>{characterObj?.endGameFact}</p>
          <div className="game-results-button-container">
            <CTAButton
              className="cta-btn"
              onClick={() => {
                goToPage('GAME_PLAY');
              }}
              primary
              intlKey={'buttons.playAgain'}
              parentNode={'GENERAL'}
            />
            <CTAButton
              className="cta-btn--link"
              onClick={() =>
                __t('market', 'GENERAL') === 'mea'
                  ? goToPage('CHARACTER_SELECTION')
                  : goToPage('CAMERA_ACCESS')
              }
              primary
              intlKey={'buttons.selectCharacter'}
              parentNode={'GENERAL'}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
